import logistic2 from "../images/logistic2.webp";
import logisticOne from "../images/logisticOne.webp";
import osenF from "../images/osenF.webp";
import rail from "../images/rail.webp";
import Warehousing from "../images/Warehousing.webp"
import { Link } from "react-router-dom";

const BannerCard = () => {
    return (
        <div className="container m-auto w-4/5 py-5">
            <div className="row grid gap-6 grid-cols-1 sm:grid-cols-2 lg:[grid-template-columns:2fr_1fr_1fr_1fr] items-center">
                <div className="bannerText">
                    <h4 className="my-5 font-bold text-[40px]">Saptasagar Overseas</h4>
                    <p className="text-[18px]">Delivering premium export-grade products worldwide with reliable sourcing, fast shipping, and unmatched customer satisfaction.</p>
                   <div className="my-10">
                    <Link to="/Contact" className="CustomBtn"><span>Contact Now</span></Link>
                   </div>
                </div>
                <div className="bannerText">
                  <div className="ImageCard">
                    <img src={logistic2} alt="Banner-One"/>
                  </div>
                </div>
                <div className="ImageCard">
                        <img src={logisticOne} alt="Banner-Two"/>
                </div>
                <div className="ImageCard">
                    <img src={osenF} alt="Banner-Three"/>
                </div>
            </div>
        </div>
    )
}
export default BannerCard;